import { ReactComponent as ExportOrdersIcon } from "../../images/export-orders.svg";
import { ISidebarIcon } from "../../interfaces/sidebar";
import { getClientTheme } from "../../utils/materialTheme";

const theme = getClientTheme();

export const renderCustomIcon = (icon: string, active?: boolean) => {
  switch (icon) {
  case "export_orders":
    return (
      <div className="sidebar-icon-margin">
        <ExportOrdersIcon
          fill={active ? theme.palette.primary.main : "#181818"}
        />
      </div>
    );
  default:
    return <></>;
  }
};

const SidebarIcon = ({ icon, isCustomIcon, active }: ISidebarIcon) => (
  <>
    {isCustomIcon ? (
      renderCustomIcon(icon, active)
    ) : (
      <span className="material-symbols-rounded text-dark sidebar-icon-margin">
        {icon}
      </span>
    )}
  </>
);

export default SidebarIcon;
